import Login from "../components/Login.vue";
import store from "../store/index";
import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../components/LoginView.vue";
import Logout from "../components/LogoutUser.vue";
import InProgress from "../components/ui/InProgress.vue";
import HomePage from "@/components/HomePage.vue";
import ActionPage from "@/components/ActionPage.vue";
import UserProfile from "@/components/UserProfile.vue";
import Forget from "../components/ForgetPassword.vue"
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    component: HomePage,
  },
  {
    path:'/forgetpassword',
    name:'forgetpassword',
    component:Forget
  },
  {
    path: "/logout",
    component: Logout,
  },
  {
    path: "/loginview",
    name:"loginview",
    component: LoginView,
  },
  {
    path: "/Action",
    component: ActionPage,
  },
  {
    path: "/notFound",
    name: "Improgress",
    component: InProgress,
  },
  {
    path: "/user",
    component: UserProfile,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
const publicPages = ["/login", "/verify", "/accountVerification", "/loginview","/forgetpassword"];

router.beforeEach((to, from, next) => {
  console.log(to, "checking route");
  const $token = localStorage.getItem("TOKEN");
  const deviceId = localStorage.getItem("deviceId");
  store.commit("SET_DEVICE_ID", deviceId);
  if (publicPages.includes(to.path)) {
    return next();
  }

  if ($token) {
    let $workTiming = localStorage.getItem("_WORK_TIMING_");
    if (!$workTiming && to.path != "/autoSuggest" && to.path != "/notFound") {
      // alert('routing'+to.path)
      return next();
    }
    let $timer = JSON.parse(localStorage.getItem("timer"));
    let $listBoard = localStorage.getItem("issueDisplay");
    if ($listBoard) {
      store.commit("SET_ISSUE_DISPLAY", $listBoard == "true" ? true : false);
    }
    //let timerData = JSON.parse(localStorage.getItem("breakormeeting"))
    if ($timer) {
      store.commit("SET_IN_PROGRESS", true);
    } else {
      store.commit("SET_IN_PROGRESS", false);
    }
    if (to.matched.length == 0) {
      return next("/notFound");
    } else {
      return next();
    }
  } else {
    return next("/login");
  }
});

export default router;
